import { AppointmentCancellationReason } from './appointmentCancellationReason'
import { AppointmentRescheduleReason } from './appointmentRescheduleReason'

type TechSetupFailureReasonCancel = Exclude<Extract<AppointmentCancellationReason, `TECH_SETUP_${string}`>, 'TECH_SETUP_INCOMPLETE'>
type TechSetupFailureReasonReschedule = Exclude<Extract<AppointmentRescheduleReason, `TECH_SETUP_${string}`>, 'TECH_SETUP_INCOMPLETE'>

type TechSetupFailureReason = TechSetupFailureReasonCancel | TechSetupFailureReasonReschedule

const TechSetupFailureReason: Record<TechSetupFailureReason, TechSetupFailureReason> = {
  TECH_SETUP_NOT_REACHED: 'TECH_SETUP_NOT_REACHED',
  TECH_SETUP_TECHNICAL_DIFFICULTIES_INTERNET: 'TECH_SETUP_TECHNICAL_DIFFICULTIES_INTERNET',
  TECH_SETUP_TECHNICAL_DIFFICULTIES_EQUIPMENT: 'TECH_SETUP_TECHNICAL_DIFFICULTIES_EQUIPMENT',
  TECH_SETUP_TECHNICAL_TABLET_NOT_ARRIVED: 'TECH_SETUP_TECHNICAL_TABLET_NOT_ARRIVED',
} as const

const techSetupReasonDisplayText: Record<TechSetupFailureReason, string> = {
  TECH_SETUP_NOT_REACHED: 'Not reached',
  TECH_SETUP_TECHNICAL_DIFFICULTIES_EQUIPMENT: 'Technical difficulties (Equipment)',
  TECH_SETUP_TECHNICAL_DIFFICULTIES_INTERNET: 'Technical difficulties (Internet)',
  TECH_SETUP_TECHNICAL_TABLET_NOT_ARRIVED: 'Tablet not arrived',
} as const

export { TechSetupFailureReason, techSetupReasonDisplayText }
